export const SHIPPING_REGULAR_NAME = 'ネコポス';

export const SHIPPING_REGULAR_PRICE = 385;

export const SHIPPING_PREMIUM_NAME = '宅急便';
